import type { StrategyItem } from '../api/strategyApi';

type BudgetFields = Pick<StrategyItem, 'benchmark_key' | 'recommended_monthly_budget'> & {
  one_time_cost?: number;
};

/**
 * A strategy's recurring monthly spend. Operational fixes generated before
 * `one_time_cost` existed stored a one-time setup cost in
 * recommended_monthly_budget (the prompt asked for that); those count as
 * one-time, not monthly. Mirrors the backend's monthlyBudgetOf.
 */
export function monthlyBudgetOf(s: BudgetFields): number {
  const legacyOneTime = s.benchmark_key === 'operational_fix' && s.one_time_cost === undefined;
  return legacyOneTime ? 0 : Number(s.recommended_monthly_budget) || 0;
}

/** A strategy's one-time (setup) cost, if any. */
export function oneTimeCostOf(s: BudgetFields): number {
  if (s.one_time_cost !== undefined) return Number(s.one_time_cost) || 0;
  return s.benchmark_key === 'operational_fix' ? Number(s.recommended_monthly_budget) || 0 : 0;
}
